<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-if="breadcrumb === 'community'" :to="{ name: 'Community' }">社区生态</el-breadcrumb-item>
        <el-breadcrumb-item v-if="breadcrumb === 'union'" :to="{ path: '/union/:id', query: { id: unionId } }">联盟生态</el-breadcrumb-item>
        <el-breadcrumb-item v-if="breadcrumb === 'research'" :to="{ path: '/research/:id', query: { id: researchId } }">研究院生态</el-breadcrumb-item>
        <el-breadcrumb-item v-if="breadcrumb === 'community'" :to="{ path: '/circleList', query: { type: 'community' } }">圈子</el-breadcrumb-item>
        <el-breadcrumb-item v-if="breadcrumb === 'union'" :to="{ path: '/circleList', query: { type: 'union', id: unionId } }">俱乐部</el-breadcrumb-item>
        <el-breadcrumb-item v-if="breadcrumb === 'research'" :to="{ path: '/circleList', query: { type: 'research', id: researchId } }">生活部落</el-breadcrumb-item>
        <el-breadcrumb-item>帖子列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="glag_left">
      <div class="cirle_head">
        <div class="cirle_head_left">
          <img :src="cirleInfo.pic" alt='' />
        </div>
        <div class="cirle_head_right">
          <div class="cirle_head_top">
            <div class="cirle_head_title lf">{{cirleInfo.board_name}}</div>
            <div class="cirle_head_other lf">
              <span>群主：{{cirleInfo.user_name}}</span>
              <el-divider direction="vertical"></el-divider>
              <span>{{cirleInfo.numbers}} 位成员</span>
              <el-divider direction="vertical"></el-divider>
              <span>{{cirleInfo.post_count}} 个话题</span>
            </div>
            <div class="cirle_head_btn rt">
              <button v-show="cirleInfo.is_join === 0 " class="my_follow_btn" @click="join(cirleInfo.board_id, cirleInfo.is_join)">加入</button>
              <button v-show="cirleInfo.is_join === 1 && cirleInfo.is_delete === 1" class="glay_btn" @click="join(cirleInfo.board_id, cirleInfo.is_join)">退出</button>
              <button v-show="cirleInfo.is_join === 1 && cirleInfo.is_delete === 0" class="glay_btn" @click="dissolutionBoard(cirleInfo.board_id)">解散</button>
            </div>
          </div>
          <div class="cirle_head_text">
            简介：{{cirleInfo.synopsis}}
          </div>
        </div>
      </div>
      <div v-if="currentUser !==null && cirleInfo.is_join == 1" class="cirle_text">
        <div class="cirle_text_left">
          <img :src="currentUser.portrait" alt="">
          <div class="cirle_text_name">
            {{currentUser.name}}
          </div>
        </div>
        <div class="cirle_text_right">
          <div class="cirle_text_textarea">
            <el-input type="textarea" v-model="apply.board_content"></el-input>
          </div>
          <div class="cirle_text_other">
            <img-view ref="imgListChild" @files="imgList" :list="apply.image_path"></img-view>
            <div class="cirle_text_btn rt">
              <button class="greenglga_sub_btn" @click="cirle_sub">发布</button>
            </div>
          </div>
        </div>
      </div>
      <!-- 话题列表 -->
      <div class="cirle_list">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span class="comment_btn" :class="topOnOff ? 'act' : ''" @click="sortBtn('hot')">热度排序</span>
            <span class="comment_btn" :class="!topOnOff ? 'act' : ''" @click="sortBtn('time')">时间排序</span>
            <el-divider></el-divider>
          </p>
        </div>
        <div v-show="listLoading" class="my_loading_box"
        v-loading="listLoading"
        element-loading-text="列表加载中"
        element-loading-spinner="el-icon-loading"
        ></div>
        <div v-if="postList.length === 0" class="my_none">暂无任何帖子，快去发布吧！</div>
        <div v-show="!listLoading" class="cirle_list_box">
          <div v-for="(item, index) in postList" :key="item.id"  class="cirle_list_item">
            <div class="cirle_list_head">
              <div class="cirle_list_head_left">
                <img :src="item.portrait" alt="头像">
              </div>
              <dl class="cirle_list_head_right">
                <dt>{{item.user_name}}</dt>
                <dd>{{item.add_time}}</dd>
              </dl>
            </div>
            <div class="cirle_list_content">
              <div class="cirle_list_content_text" @click="jump(item.id)">{{item.board_content}}</div>
              <div class="cirle_list_content_img_list">
                <viewer :images="item.image_path">
                <img class="cirle_list_content_img_item"
                  v-for="(src,index) in item.image_path"
                  :src="src"
                  :key="index"
                >
                </viewer>
              </div>
            </div>
            <div class="cirle_list_other rt">
              <el-breadcrumb separator="|">
                <el-breadcrumb-item class="my_icon_box"><a @click="layerPinglun(item.id, item)"><i class="my_icon pinglun"></i><span class="my_icon_text">{{item.comment_count}}</span></a></el-breadcrumb-item>
                <el-breadcrumb-item class="my_icon_box" :class="item.is_like === 0 ? '' : 'act'"><a @click="doLike(item.id, item.is_like, index)"><i class="my_icon dianzan"></i><span class="my_icon_text">{{item.post_like}}</span></a></el-breadcrumb-item>
                <el-breadcrumb-item
                :class="currentUser.id === cirleUser.board_leader.user_id || currentUser.id === item.user_id ? 'my_icon_box' : 'my_icon_box r_border'">
                  <a @click="reportLayer = true">
                    <i class="my_icon jubao"></i>
                    <span class="my_icon_text">举报</span>
                  </a>
                  <!-- 举报弹窗 -->
                  <el-dialog title="举报信息" :visible.sync="reportLayer" width="400px">
                    <el-form :model='report'>
                      <el-form-item label="举报类别" label-width='80px'>
                        <el-select v-model="report.type" placeholder="请选择举报类别">
                          <el-option label="垃圾广告" value="垃圾广告"></el-option>
                          <el-option label="辱骂人身攻击等不友善行为" value="辱骂人身攻击等不友善行为"></el-option>
                          <el-option label="涉政" value="涉政"></el-option>
                          <el-option label="其它原因" value="其它原因"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="reportLayer = false">取 消</el-button>
                      <el-button type="primary" @click="reportMesConfirm(item.id)">确 定</el-button>
                    </div>
                  </el-dialog>
                </el-breadcrumb-item>
                <el-breadcrumb-item
                v-if="currentUser.id === cirleUser.board_leader.user_id || currentUser.id === item.user_id"
                class="my_icon_box r_border">
                  <el-popconfirm
                    title="您确定删除帖子内容？"
                    confirm-button-text='删除'
                    cancel-button-text='再想想'
                    @onConfirm="del(item.id, index)"
                  >
                    <a slot="reference"><i class="my_icon shanchu"></i><span class="my_icon_text">删除</span></a>
                  </el-popconfirm>
                </el-breadcrumb-item>
                <el-breadcrumb-item></el-breadcrumb-item>
              </el-breadcrumb>
              <el-dialog title="评论列表" custom-class="commentDialogt" :visible.sync="layerPinglunOnOff" width="780px">
                <comment-view :comments="commentList" :user="user" :list-id="commentPage.dynamic_id"></comment-view>
              </el-dialog>
            </div>
          </div>
        </div>
      </div>
      <div v-if="postList.length > 0" class="cirle_page">
        <page-view :list="postList" :limit="listPage.limit" @page="page"></page-view>
      </div>
    </div>
    <!-- 圈子成员 -->
    <div class="glag_right">
      <div class="title_top_hr">
        <p>
          <i></i>
          <span>圈子成员</span>
        </p>
        <el-divider></el-divider>
      </div>
      <div v-if="cirleUser !== null" class="cirle_user">
        <div class="cirle_user_head">
          <div class="cirle_user_title">
            圈主
          </div>
          <div class="cirle_user_list">
            <div class="cirle_user_item lf">
              <img :src="cirleUser.board_leader.portrait" alt="">
              <p>{{cirleUser.board_leader.user_name}}</p>
            </div>
          </div>
        </div>
        <div v-if="cirleUser.administrators.length > 0" class="cirle_user_center">
          <div class="cirle_user_title">
            管理员
          </div>
          <div class="cirle_user_list">
            <div v-for="item in cirleUser.administrators" :key="item.id" class="cirle_user_item lf">
              <img :src="item.portrait" alt="">
              <p>{{item.user_name}}</p>
            </div>
          </div>
        </div>
        <div class="cirle_user_foot">
          <div class="cirle_user_title">
            成员
          </div>
          <div v-if="cirleUser.user_list.lenght === 0" class="my_none">
            圈子暂无成员
          </div>
          <div v-else class="cirle_user_list">
            <div v-for="item in cirleUser.user_list" :key="item.id" class="cirle_user_item lf">
              <img :src="item.portrait" alt="">
              <p>{{item.user_name}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uploadImg from '../Public/imgListUpload.vue'
import page from '../Public/page.vue'
import comment from '../Public/cirleComment.vue'
export default {
  components: {
    imgView: uploadImg,
    pageView: page,
    commentView: comment
  },
  data () {
    return {
      webTitle: '', // 网页标题
      breadcrumb: '', // 面包屑
      unionId: '', // 联盟id
      researchId: '', // 研究院id
      listLoading: true, // 列表加载动画
      currentUser: null, // 当前登录用户
      cirleInfo: {}, // 圈子信息
      cirleUser: {
        board_leader: { portrait: '' },
        administrators: [{ portrait: '' }],
        user_list: [{ portrait: '' }]
      }, // 圈子成员
      apply: {
        board_id: '',
        board_title: '',
        board_content: '',
        image_path: []
      },
      topOnOff: true, // 列表分栏选中
      postList: [], // 帖子列表
      listPage: {
        board_id: '', // 圈子id
        limit: 10, // 每页条目数
        page: 1, // 页码
        order: 1 // 1 热度排序 2时间排序
      },
      layerPinglunOnOff: false, // 评论列表弹窗
      commentPage: {
        dynamic_id: '',
        limit: 10,
        page: 1,
        type: 1
      },
      commentList: { // 评论列表
        comments: []
      },
      user: {
        id: 0,
        user_name: ''
      }, // 作者信息
      reportLayer: false, // 举报弹窗
      report: { // 举报类别
        dynamic_id: '',
        type: '' // 举报信息类别
      }
    }
  },
  created () {
    const vueThat = this
    vueThat.currentUser = vueThat.$store.state.user.info
    vueThat.listPage.board_id = vueThat.$route.query.id
    vueThat.apply.board_id = vueThat.$route.query.id
    vueThat.myApi.getBoardDetails({ board_id: vueThat.listPage.board_id }).then((res) => {
      if (res.data.code === 200) {
        vueThat.cirleInfo = res.data.data.board
        vueThat.webTitle = res.data.data.board.board_name
        document.title = this.webTitle // 网页标题修改
        vueThat.cirleUser = res.data.data.users
        if (vueThat.cirleInfo.type === 1) {
          vueThat.breadcrumb = 'community'
        } else if (vueThat.cirleInfo.type === 2) {
          vueThat.breadcrumb = 'union'
          vueThat.unionId = vueThat.cirleInfo.union_id
        } else {
          vueThat.breadcrumb = 'research'
          vueThat.researchId = vueThat.cirleInfo.research_id
        }
      }
    })
    vueThat.myApi.boardPostList(vueThat.listPage).then((res) => {
      if (res.data.code === 200) {
        vueThat.listLoading = false
        vueThat.postList = res.data.data
      }
    })
  },
  methods: {
    // 加入/退出 圈子
    join (id, isJoin) {
      const vueThat = this
      if (isJoin === 0) {
        vueThat.myApi.applyBoard({ board_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.cirleInfo.is_join = 1
          }
        })
      } else {
        vueThat.myApi.retreatBoard({ board_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.cirleInfo.is_join = 0
          }
        })
      }
    },
    // 解散圈子
    dissolutionBoard (id) {
      this.myApi.dissolutionBoard({ board_id: id }).then((res) => {
        if (res.data.code === 200) {
          this.$alert('圈子解散成功！', '温馨提示', {
            type: 'success',
            confirmButtonText: '确认',
            showClose: false,
            callback: () => {
              window.close()
            }
          })
        } else {
          this.$alert('圈子解散失败，请重新确认信息！', '温馨提示', {
            type: 'error',
            confirmButtonText: '确认',
            showClose: false,
            callback: () => {
            }
          })
        }
      })
    },
    // 获取发布图片列表
    imgList (list) {
      this.apply.image_path = []
      for (let i = 0; i < list.length; i++) {
        this.apply.image_path.push(list[i].url)
      }
    },
    // 发布按钮
    cirle_sub () {
      const vueThat = this
      if (vueThat.apply.board_content === '' && vueThat.apply.image_path.length === 0) {
        vueThat.$message({
          message: '发布内容不能为空！',
          type: 'error'
        })
      } else {
        vueThat.listLoading = true
        vueThat.myApi.boardDynamicCreate(vueThat.apply).then((res) => {
          if (res.data.code === 200) {
            vueThat.$message({
              message: '发布成功！',
              type: 'success'
            })
            vueThat.apply.board_title = ''
            vueThat.apply.board_content = ''
            vueThat.apply.image_path = []
            vueThat.listPage.order = 2
            vueThat.myApi.boardPostList(vueThat.listPage).then((res) => {
              if (res.data.code === 200) {
                vueThat.listLoading = false
                vueThat.postList = res.data.data
              }
            })
            vueThat.$refs.imgListChild.clearImgList()
          }
        })
      }
    },
    // 时间、热度排序切换
    sortBtn (type) {
      const vueThat = this
      vueThat.topOnOff = !vueThat.topOnOff
      vueThat.listLoading = true
      if (type === 'hot') {
        vueThat.listPage.order = 1
      } else {
        vueThat.listPage.order = 2
      }
      vueThat.myApi.boardPostList(vueThat.listPage).then((res) => {
        if (res.data.code === 200) {
          vueThat.listLoading = false
          vueThat.postList = res.data.data
        }
      })
    },
    // 点击评论弹窗弹出
    layerPinglun (rid, data) {
      const vueThat = this
      vueThat.commentPage.dynamic_id = rid
      vueThat.user.id = data.user_id
      vueThat.user.user_name = data.user_name
      vueThat.myApi.boardMesSort(vueThat.commentPage).then((res) => {
        if (res.data.code === 200) {
          vueThat.commentList.comments = res.data.data
          this.layerPinglunOnOff = true
        }
      })
    },
    // 点赞 / 取消点赞
    doLike (id, isLike, index) {
      const vueThat = this
      if (isLike === 0) {
        vueThat.myApi.boardDoLike({ dynamic_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.postList[index].is_like = 1
            vueThat.postList[index].post_like += 1
          }
        })
      } else {
        vueThat.myApi.boardCancelLike({ dynamic_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.postList[index].is_like = 0
            vueThat.postList[index].post_like -= 1
          }
        })
      }
    },
    // 图片预览
    show () {
      const viewer = this.$el.querySelector('.images').$viewer
      viewer.show()
    },
    // 加载更多
    page (num) {
      console.log(num)
      const vueThat = this
      vueThat.listPage.page = num
      vueThat.myApi.boardPostList(vueThat.listPage).then((res) => {
        if (res.data.code === 200) {
          vueThat.listLoading = false
          vueThat.postList.push(...res.data.data)
        }
      })
    },
    // 举报确认按钮
    reportMesConfirm (id) {
      const vueThat = this
      vueThat.report.dynamic_id = id
      vueThat.myApi.BoardReport(vueThat.report).then((res) => {
        if (res.data.code === 200) {
          vueThat.reportLayer = false
          vueThat.$message({
            message: '举报信息提交成功！',
            type: 'success'
          })
        }
      })
    },
    // 帖子删除
    del (id, index) {
      console.log('调用了？')
      const vueThat = this
      vueThat.myApi.boardDynamicDel({ dynamic_id: id }).then((res) => {
        if (res.data.code === 200) {
          vueThat.postList.splice(index, 1)
          vueThat.$message.success('删除成功！')
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
  .el-upload--picture-card{
   width: 70px;
   height: 80px;
   line-height: 80px;
  }
  .el-upload--picture-card i{
    font-size: 14px;
  }
  .el-upload-list--picture-card .el-upload-list__item{
    width: 70px;
    height: 80px;
  }
  .comment_box{
    margin: 0;
  }
</style>
